import * as PRESCRIPTION from '@/store/constants/prescription';

export default {
  [PRESCRIPTION.GET_PRESCRIPTION_LIST]: (state) => {
    return state.list;
  }
}



// WEBPACK FOOTER //
// ./src/store/prescription/getters.js